import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 60%',
          maxWidth: '60%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '60vw',
          },
        },
      },
    },
  },
  
  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      maxHeight: '72px',
    },
    '& .topbar-listitem': {
      '& .MuiButtonBase-root': {  
        paddingInline: '0px !important',
        minWidth: '80px !important',
      },
    },
    '& .menu-item, .header-phone-link': {
      fontSize: '16px',
      paddingInline: '4px !important',
      textTransform: 'none',
    },
    '& .MuiButton-containedPrimary':{
      background: `${palette.secondary.main} !important`,
      color: `${palette.text.highlight} !important`,
      paddingInline: '24px !important',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.surface.pricing,
        color: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      backgroundColor: palette.background.primary,
      '& .hero-header-title': {
        fontFamily: 'Georgia !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        fontWeight: 400,
        color: palette.text.highlight,
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
        },
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Futura !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        color: palette.text.highlight,
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
        },
      },
      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
      '& .hero-home-button': {
        color: palette.text.highlight,
        fontSize: '16px !important',
        border: '1px solid !important',
        borderColor: palette.text.highlight,
      },
      '& .hero-link-button': {
        backgroundColor: palette.text.highlight,
        color: palette.text.alternate,
        fontSize: '16px !important',
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.background.primary,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        background: `${palette.surface.light} !important`,
        border: `1px solid ${palette.background.primary} !important`,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.default,
      backgroundImage: `url('/images/home-images/hero-pattern.svg')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom left',
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title, & .home-hero-title': {
          fontSize: 64,
          fontWeight: 400,
          lineHeight: '72px',
          fontFamily: 'Georgia !important',
          letterSpacing: '-1.28px',

          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: 52,
            lineHeight: '64px',
            letterSpacing: '-1.04px',
          },

          '@media(max-width: 600px)': {
            fontSize: 44,
            lineHeight: '48px',
            letterSpacing: '-0.88px',
          },
        },
        '& .hero-subtitle, & .home-hero-subtitle': {
          fontWeight: 400,
          fontSize: 24,
          lineHeight: '28px',
          maxWidth: 540,
          letterSpacing: '-0.48px',
          fontFamily: 'Futura !important',
          '@media(max-width: 600px)': {
            fontSize: 18,
            lineHeight: '22px',
            letterSpacing: '-0.36px',
          },
          '@media(max-width: 1200px) and (min-width: 600px)': {
            fontSize: 20,
            lineHeight: '24px',
            letterSpacing: '-0.4px',
          },
        },
      },
      '& .section-header__subtitle-wrapper': {
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .primary-button': {
        background: `${palette.secondary.main} !important`,
      },
      '& .image-wrapper': {
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
          padding: 24,
        },
      },
      '@media(min-width: 900px)': {
        '& .section-alternate__content': {
          paddingTop: 40,
          paddingBottom: 40,
          paddingInline: '16px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 900px)': {
        '& .section-alternate__content': {
          paddingInline: '0px !important',
        },
      },
      '@media(max-width: 600px)': {
        '& .hero-left-section': {
          padding: 24,
        },
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle, .home-hero-title, .home-hero-subtitle': {
          textAlign: 'center',
        },
        '& .section-header': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .home-hero-subtitle': {
          fontFamily: 'Futura !important',
        },
        '& .section-header__cta-wrapper': {
          '@media(max-width: 900px)': {
            maxWidth: '100vw !important',
            width: '100vw !important',
          },
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 1024px)': {
                display: 'flex',
              },
            },
          },
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      '& .definition-variant-3': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '24px !important',
        },
      },
      '@media(max-width: 1200px)': {
        padding: '20px !important',
        paddingBottom: '60px !important',
      },
      backgroundColor: palette.background.secondary,
      '& .benefits-wrapper': {
        display: 'flex',
        justifyContent: 'space-around',
        '& .MuiGrid-container': {
          display: 'flex',
          justifyContent: 'space-around',
        },
        '& .customRightContainer': {
          '@media(max-width: 600px)': {
            padding: '0px !important',
          },
        },
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          padding: '0px !important',
          paddingLeft: '16px !important',
          '@media(max-width: 600px)': {
            height: '400px !important',
            minHeight: '400px !important',
            width: '382px !important',
            maxWidth: '382px !important',
            paddingBottom: '24px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
            width: '912px !important',
            maxWidth: '912px !important',
            paddingBottom: '24px !important',
          },
          '@media(min-width: 1200px)': {
            height: '640px !important',
            minHeight: '640px !important',
            width: '480px !important',
            maxWidth: '480px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-service-tile': {
        borderBottom: `0.5px solid ${palette.background.border} !important`,
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontWeight: 400,
        fontFamily: 'Georgia !important',
        fontSize: '28px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.56px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          letterSpacing: '-0.44px !important',
        },
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        color: palette.text.secondary,
      },
      '& .section-header__title': {
        fontWeight: 400,
        whiteSpace: 'pre-line',
        fontFamily: 'Georgia !important',
        fontSize: '52px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.04px !important',
        paddingBottom: '24px !important',
        '@media(max-width: 1200px) and (min-width: 600px)': {
          fontSize: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: `url('/images/home-images/pricing-bg.webp') no-repeat center center`,
        backgroundSize: 'cover',
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label, .savings-summary-link':
      {
        color: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        fontWeight: 400,
        fontFamily: 'Georgia !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        whiteSpace: 'pre-line',
        letterSpacing: '-1.68px !important',
        '@media screen and (max-width: 600px)': {
          fontSize: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Futura !important',
        fontSize: '24px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        color: palette.text.highlight,
        '@media screen and (max-width: 700px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& .subscription-tabs-label': {
        color: palette.text.primary,
        fontSize: '14px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.28px !important',
      },
      '& #pricing-benefit-section': {
        '& .react-multi-carousel-list': {
          width: '100% !important',
          maxWidth: '100% !important',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
        },
        '& .react-multi-carousel-track': {
          width: '100% !important',
          display: 'flex !important',
          transform: 'none !important',
          justifyContent: 'center',
          '@media(max-width: 1199px)': {
            margin: '0 auto',
          },
          '@media(min-width: 1200px)': {
            gap: '24px',
          },
        },
        '& .react-multi-carousel-item': {
          width: '100% !important',
          minWidth: '100% !important',
          maxWidth: '100% !important',
          '@media(max-width: 1199px)': {
            display: 'flex',
            justifyContent: 'center',
          },
          '@media(min-width: 1200px)': {
            width: '100% !important',
            minWidth: '100% !important',
            flexShrink: 0,
          },
        },
        '& .carousel-single-item': {
          width: '100% !important',
          maxWidth: '100% !important',
          justifyContent: 'center !important',
          '@media(max-width: 1199px)': {
            margin: '0 auto',
            maxWidth: '100% !important',
          },
          '@media(min-width: 1200px)': {
            maxWidth: 'fit-content !important',
            margin: '0 auto',
          },
        },
        '& .carousel-single-item > .MuiGrid-item': {
          '@media(max-width: 1199px)': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
          },
          '@media(min-width: 1200px)': {
            maxWidth: 'calc(33.333% - 16px) !important',
            flexBasis: 'calc(33.333% - 16px) !important',
            width: 'calc(33.333% - 16px) !important',
          },
        },
        '& .planCard': {
          width: '100% !important',
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          border: 'none',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.background.light,
            color: palette.text.brand,
            '&:hover': {
              backgroundColor: palette.secondary.main,
              color: palette.primary.contrastText,
              transition: 'none !important',
            },
          },
          '& .price-value': {
            fontWeight: '500 !important',
            fontFamily: 'Futura !important',
            fontSize: '32px !important',
            lineHeight: '32px !important',
            letterSpacing: '-0.64px !important',
          },
          '& .customcardTitle': {
            fontWeight: 400,
            fontFamily: 'Georgia !important',
            fontSize: '28px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.56px !important',
            marginBottom: '8px !important',
          },
          '& .price-frequency': {
            fontSize: '16px !important',
            color: palette.text.secondary,
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
          },
          '& .customSubscriberName': {
            fontSize: '16px !important',
            color: palette.text.secondary,
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
          },
          '& .bold': {
            fontSize: '20px !important',
            color: palette.text.primary,
            lineHeight: '24px !important',
            letterSpacing: '-0.4px !important',
          },
          '& .cptCodes': {
            fontSize: '16px !important',
            color: palette.text.primary,
            lineHeight: '20px !important',
            letterSpacing: '-0.28px !important',
          },
          '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
            },
            '& .disclaimerText': {
              fontSize: '14px !important',
              color: palette.text.tertiary,
            },
            '& .bold': {
              fontSize: '14px !important',
              lineHeight: '20px !important',
              color: palette.text.tertiary,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .summary-text': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.4px !important',
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.4px !important',
          },
        },
        '& .summary-subtext': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.4px !important',
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.4px !important',
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          cursor: 'pointer',
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.32px !important',
          },
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.main,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1600px)': {
          padding: '40px 64px !important',
        },
        '@media(min-width: 1600px)': {
          padding: '60px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
          borderRadius: '24px',
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Georgia !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          fontWeight: 400,
          '@media(max-width: 900px)': {
            marginTop: '24px !important',
          },
          '@media(max-width: 1200px)': {
            fontSize: '48px !important',
            lineHeight: '56px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(min-width: 900px)': {
          paddingRight: '60px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.tableHead,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '@media(max-width: 900px)': {
          maxWidth: '100% !important',
        },
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          fontWeight: 400,
          marginBottom: 10,
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.tertiary,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
        },
        '&:not(:last-child)': {
          borderBottom: `1px solid ${palette.background.border} !important`,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        backgroundColor: palette.background.primary,
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.text.brand} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.offer} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
        textTransform: 'uppercase',
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-button-wrapper': {
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'right !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
        },
      },
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '20px !important',
          '@media(max-width: 600px)': {
            paddingTop: '24px !important',
            paddingBottom: '24px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      '& .section-header': {
        '@media(max-width: 600px)': {
          padding: '24px 0 !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.surface.light} !important`,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontWeight: 400,
        fontFamily: 'Georgia !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle-wrapper': {
        '@media(max-width: 600px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.secondary,
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 600px)': {
          maxWidth: '280px !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Futura !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Futura !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.background.primary,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.background.primary,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.surface.light} !important`,
        border: `1px solid ${palette.background.primary} !important`,
      },
      '& .customDetailsContainer': {
        '& .MuiButtonBase-root': {
          lineHeight: '20px !important',
          paddingInline: '0px !important',
          textTransform: 'none !important',
        },
        '& .MuiAccordionSummary-root': {
          paddingInline: '22px !important',
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        fontSize: '16px !important',
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
        '@media(max-width: 600px)': {
          maxWidth: '380px !important',
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.surface.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 700px)': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: '0px !important',
        paddingRight: '8px !important',
      },
      '& .contact-card-title': {
        fontFamily: 'Georgia !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        fontWeight: 400,
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .provider-contact-details': {
        fontSize: '18px !important',
        fontFamily: 'Futura !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        paddingBottom: '8px !important',
      },
      '& .provider-contact-link': {
        color: palette.text.secondary,
        fontSize: 20,
        lineHeight: '20px !important',
        letterSpacing: '-0.6px !important',
        fontWeight: 400,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
      '& .MuiButton-containedPrimary': {
        background: `${palette.background.main} !important`,
        color: `${palette.text.brand} !important`,
        border: `1px solid ${palette.text.brand} !important`,
      },  
      '& .MuiButton-containedSecondary': {
        background: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.secondary.main,
        color: palette.secondary.main,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.secondary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.secondary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.secondary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.secondary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.secondary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.secondary.main, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      color: palette.text.highlight,
      '& a': {
        color: palette.text.highlight,
      },
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
      '& .logo-image': {
        marginBottom: '80px !important',
        marginTop: '40px !important',
      },
    },
  },
};
